<!-- eslint-disable max-len -->
<template>
  <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M26 16.6088L26 7.43685C26 6.98729 25.7 6.59298 25.2667 6.47307L16.2667 3.98251C16.0922 3.93421 15.9078 3.93421 15.7333 3.98251L6.7333 6.47307C6.30001 6.59298 6 6.98728 6 7.43685L6 16.6088C6 20.4739 8.02855 24.0554 11.3435 26.0429L15.4858 28.5266C15.8023 28.7164 16.1977 28.7164 16.5142 28.5266L20.6565 26.0429C23.9715 24.0554 26 20.4739 26 16.6088ZM6.19988 4.54552C4.90003 4.90523 4 6.08814 4 7.43685L4 16.6088C4 21.1766 6.39737 25.4093 10.315 27.7582L14.4573 30.2419C15.407 30.8113 16.593 30.8113 17.5427 30.2419L21.685 27.7582C25.6026 25.4093 28 21.1766 28 16.6088L28 7.43685C28 6.08814 27.1 4.90523 25.8001 4.54552L16.8001 2.05495C16.2765 1.91006 15.7235 1.91006 15.1999 2.05495L6.19988 4.54552Z"
      fill="currentColor"
    />
    <rect x="9" y="12.5" width="14" height="6" rx="3" stroke="currentColor" stroke-width="2" />
    <rect x="16" y="12" width="7" height="7" rx="3.5" fill="currentColor" />
  </svg>
</template>
